// @ts-nocheck
import React from 'react';
export default ({ children }: { children: React.ReactNode }) => children
